///***
// 
// 
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// Cambio a useCargarSeriesProductos.store.ts
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// 
// *//


import { getUbicacionProductoByCodigoIdUbicacion, postGenerarSeries } from "@/shared/actions/erp";
import { AlertSeverityEnum, MaterialTransferido } from "@/shared/interfaces";
import { ChangeEvent } from "react";
import { create } from "zustand";
//import { read, utils } from 'xlsx';
import { encontrarNoCoincidencias, handleAxiosError, texto } from "@/shared";
import { useUiStore } from "@/store/ui";

interface ICargarSeries {

  openModalSeries: boolean
  setOpenModalSeries: (openModalSeries: boolean) => void

  viewSelectSerie: boolean
  setViewSelectSerie: (viewSelectSerie: boolean) => void


  auxRow: MaterialTransferido
  setAuxRow: (auxRow: MaterialTransferido) => void

  handleGenerarSeries: (codigo: string, cantidad: number | string) => void
  handleFileExcel: (event: ChangeEvent<HTMLInputElement>) => void
  handleFileTxt: (event: ChangeEvent<HTMLInputElement>) => void
  handleAutomatico: (series: string[], cantidad: number | string) => void

  handelValidationSerie: () => boolean
  handelValidationSerieModal: (materialTransferido: MaterialTransferido, ubicacion: string) => Promise<boolean>

}

export const useCargarSeries = create<ICargarSeries>((set, get) => ({
  viewSelectSerie: false,
  setViewSelectSerie(viewSelectSerie) {
    set({ viewSelectSerie })
  },
  openModalSeries: false,
  setOpenModalSeries(openModalSeries) {
    set({ openModalSeries })
  },
  auxRow: {
    cantidad: 0,
    codigo: '',
    id: '',
    producto_data: null,
    series: []
  },
  setAuxRow(auxRow) {
    set({ auxRow })
  },

  ///* Funcion para generar series automaticas
  async handleGenerarSeries(codigo, cantidad) {

    //convierte a entero cuando es string la cantidad
    const cantidad1 = Number(cantidad)
    let series = await postGenerarSeries({
      producto: codigo,
      inicio: 1,
      cantidad: cantidad1,
      prefijo: `${codigo}-`
    });

    set({
      auxRow: {
        ...get().auxRow,
        series: series.data
      }
    })
  },

  ///* Funcion para cargar series desde un archivo excel
  handleFileExcel(event) {
    if (event.target.files) {
      const file = event.target.files[0];

      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target?.result;
        if (data) {
          const wb = XLSX.read(data, { type: 'binary' });
          const ws = wb.Sheets[wb.SheetNames[0]];
          const seriesExcel = XLSX.utils.sheet_to_json<{ numero_serie: string }>(ws, { header: ["numero_serie"] });

          let aux: string[] = [];
          seriesExcel.forEach((element: { numero_serie: string }) => {
            aux.push(element.numero_serie)
          });

          set({
            auxRow: {
              ...get().auxRow,
              series: aux
            }
          })
        }
      };
      reader.readAsArrayBuffer(file);
    }
  },

  ///* Funcion para cargar series desde un archivo txt
  handleFileTxt(event) {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const content = event.target?.result as string;
        const lines = content.trim().split('\n');

        let aux: string[] = [];
        lines.forEach(element => {
          if (element.replace(/\s+/g, '')) {
            aux.push(element.replace('\r', ''));
          }
        });

        set({
          auxRow: {
            ...get().auxRow,
            series: aux
          }
        })
      };
      reader.readAsText(file);
    }
  },

  ///* Funcion para selecionar series automaticas
  handleAutomatico(series, cantidad) {

    const setAlert = useUiStore.getState().setAlert;
    const cantidadNumber = Number(cantidad)

    if ((series.length + 1) <= cantidadNumber)
      return setAlert(true, 'La cantidad excede al número de series encontradas', AlertSeverityEnum.info)

    const aux = series.slice(0, cantidadNumber);

    setAlert(true, 'Series seleccionadas automaticamente', AlertSeverityEnum.success);

    set({
      auxRow: {
        ...get().auxRow,
        series: aux
      }
    })
  },

  ///* Funcion para validar series al enviar a la api
  handelValidationSerie(): boolean {
    const setAlert = useUiStore.getState().setAlert;

    const auxRow = get().auxRow;

    if (auxRow?.series?.length == 0) {
      setAlert(true, 'Cargar o Seleccionar las series por Transferir', AlertSeverityEnum.error);
      return false;
    }

    if ((auxRow?.cantidad != auxRow?.series?.length) && auxRow?.contiene_serie) {
      setAlert(true, texto.series_no_igual_cantidad, AlertSeverityEnum.error);
      return false;
    }

    const con = encontrarNoCoincidencias(auxRow?.selected_series!, auxRow?.series!);
    if (con.length > 0) {
      const serie = con.join(',')
      setAlert(true, `Serie(s): ${serie} no existen para el producto: ${auxRow?.producto_data?.codigo}`, AlertSeverityEnum.error);
      return false;
    }

    return true;
  },

  async handelValidationSerieModal(materialTransferido: MaterialTransferido, ubicacion: string): Promise<boolean> {
    try {
      const setAlert = useUiStore.getState().setAlert;

      //console.log('ubicacion', ubicacion)
      if (!materialTransferido.contiene_serie) {
        setAlert(true, 'Marcar la opcion de "Contiene Series" para habilitar la funcion', AlertSeverityEnum.info);
        return false;
      }

      if (materialTransferido.cantidad === 0) {
        setAlert(true, 'No es posible seleccionar series si la cantidad es 0', AlertSeverityEnum.info);
        return false;
      }

      const respProducto = await getUbicacionProductoByCodigoIdUbicacion(
        {
          producto: materialTransferido.producto_data?.codigo!,
          ubicacion: ubicacion,
        }
      );

      const series = respProducto.series;

      if (series == null || series.length === 0) {
        setAlert(true, 'El producto no contiene series', AlertSeverityEnum.info);
        return false;
      }

      set({
        auxRow: {
          ...materialTransferido, selected_series: series
        }
      })

      return true;
    } catch (error) {
      handleAxiosError(error);
      throw new Error('Error: ' + error,)
    }
  },
}))